export default __webpack_public_path__ + "static/media/real-assets.52b8603d.svg";